module.exports = __webpack_public_path__ + "img/bg.621f179b.png";